"use client"
import { Content } from "@prismicio/client"
import { SliceComponentProps } from "@prismicio/react"
import { EmblaOptionsType } from "embla-carousel"

import EmblaCarousel from "./EmblaCarousel"

const OPTIONS: EmblaOptionsType = { align: "start" }
/**
 * Props for `FlipCard`.
 */
export type FlipCardProps = SliceComponentProps<Content.FlipCardSlice>

/**
 * Component for "FlipCard" Slices.
 */
const FlipCard = ({ slice }: FlipCardProps): JSX.Element => {

  return (
    <section
      className="relative"
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <EmblaCarousel slides={slice.items} options={OPTIONS} />
    </section>
  )
}

export default FlipCard
